/** Transparent product mockup: 6 volumes + tablet, laptop and phone. */
export const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/mzDPUMdwXeWcbwRYYAGinZ/MockUp_(mari_ingles).png'

export const TEACHING_INSTRUCTOR_URL =
  'https://cdn.magicpatterns.com/patterns/generated-images/d2e60d2a-f837-488a-a9e6-77d6e76fef65.jpg'
